// Calendar arithmetic uses UTC for civil dates, independent of device timezone/DST.
export function shiftMonth(month: string, offset: number): string {
 const [year, number] = month.split('-').map(Number);
 return new Date(Date.UTC(year, number - 1 + offset, 1)).toISOString().slice(0, 7);
}
export function absenceMonthDays(month: string): Array<string | null> {
 const [year, number] = month.split('-').map(Number);
 const first = new Date(Date.UTC(year, number - 1, 1));
 const count = new Date(Date.UTC(year, number, 0)).getUTCDate();
 return [...Array<null>((first.getUTCDay() + 6) % 7).fill(null), ...Array.from({length:count},(_,i)=>`${month}-${String(i+1).padStart(2,'0')}`)];
}
